Returns the authenticated credential and the global catalog of scopes available in the product.

<ApiCodeExamples exampleId="metaScopes" />

<ApiResponseExamples exampleId="metaScopes" />

## Main fields in the `200` response

- `credential`: current snapshot of the authenticated credential.
- `credential.scopes`: scopes currently assigned to the credential.
- `credential.allowed_ips`: effective IP allowlist, when configured.
- `credential.rate_limit_per_minute`: operational per-minute limit for this credential.
- `available_scopes`: global catalog of scopes recognized by the platform.

Implemented scope codes: `campaigns.read`, `calls.read`, `calls.write`, `agents.read`, `scripts.read`, `users.read`, `transfer_groups.read`.

## When to use this endpoint

- verify which scopes the current credential actually has;
- compare the global scope catalog against the scopes already assigned;
- debug `403 Forbidden` or permission gaps in external integrations.
